<div
  class="[ flex flex-column flex-column-reverse gap-3xs items-center justify-center ][ corner-m ]"
  data-cy="navigation-rail-item"
  >
  @if (label) {
    <label
      class="[ label-medium text-center ]"
    [ngClass]="{
      'cursor-pointer': !disabled,
      'group-hover:on-surface': !disabled,
      'group-focus-visible:on-surface': !disabled,
      'on-surface': selected,
      'on-surface-variant': !selected,
      disabled: disabled
    }"
      >{{ label }}
    </label>
  }
  <div
    class="icon-container [ relative ] [ flex items-center justify-center corner-full ]"
    [class.primary-container]="selected"
    #iconContainer
    >
    <span class="[ relative inline-flex justify-center items-center ]">
      <campus-icon
        [svgIcon]="selected ? 'filled:' + icon : icon"
        [ngClass]="{
          'group-hover:on-surface': !disabled,
          'group-focus-visible:on-surface': !disabled,
          'on-primary-container': selected,
          'on-surface-variant': !selected,
          disabled: disabled
        }"
        aria-hidden="true"
      ></campus-icon>
      @if (badge) {
        <campus-badge
          [value]="badge"
          [size]="badgeSize"
          class="rail-item-badge [ absolute ]"
        ></campus-badge>
      }
    </span>
    @if (!disabled) {
      <campus-state-layer
        [for]="element"
        [ngClass]="selected ? 'bg-on-primary-container' : 'bg-primary'"
      ></campus-state-layer>
    }
    @if (!disabled) {
      <campus-focus-ring [for]="element"></campus-focus-ring>
    }
  </div>
</div>
